import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=586a63a8&"
import script from "./profile.js?vue&type=script&lang=js&"
export * from "./profile.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports